import { useRef, useState } from 'react';
import {
  Box,
  Button,
  ClickAwayListener,
  Link,
  Paper,
  Popper,
  Typography
} from '@mui/material';
import WarningAmberRounded from '@mui/icons-material/WarningAmberRounded';
import { requestAdminNavigation } from 'src/navigation/adminNavigationGuard';

export default function QuoteApprovalCaution({ eventId }: { eventId: number }) {
  const anchor = useRef<HTMLButtonElement>(null);
  const suppressFocus = useRef(false);
  const [open, setOpen] = useState(false);
  const [pinned, setPinned] = useState(false);
  const detailId = `quote-approval-caution-${eventId}`;
  const close = () => {
    setOpen(false);
    setPinned(false);
  };
  return (
    <ClickAwayListener onClickAway={close}>
      <Box
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={(event) => {
          if (!pinned && !event.currentTarget.contains(document.activeElement))
            setOpen(false);
        }}
        onFocus={() => {
          if (suppressFocus.current) suppressFocus.current = false;
          else setOpen(true);
        }}
        onBlur={(event) => {
          if (!event.currentTarget.contains(event.relatedTarget as Node))
            close();
        }}
        onKeyDown={(event) => {
          if (event.key === 'Escape') {
            event.stopPropagation();
            close();
            if (document.activeElement !== anchor.current) {
              suppressFocus.current = true;
              anchor.current?.focus();
            }
          }
        }}
      >
        <Button
          ref={anchor}
          size="small"
          startIcon={<WarningAmberRounded fontSize="small" />}
          aria-expanded={open}
          aria-controls={open ? detailId : undefined}
          onClick={() => {
            if (pinned) close();
            else {
              setPinned(true);
              setOpen(true);
            }
          }}
          sx={{
            color: '#795800',
            bgcolor: '#fff6d8',
            border: '1px solid #e6ce82',
            borderRadius: 1.5,
            fontSize: 12,
            textTransform: 'none'
          }}
        >
          Quote Not Approved
        </Button>
        <Popper
          open={open}
          anchorEl={anchor.current}
          placement="top-start"
          disablePortal
          sx={{
            zIndex: (theme) => theme.zIndex.tooltip,
            maxWidth: 'calc(100vw - 32px)'
          }}
        >
          <Paper
            id={detailId}
            elevation={6}
            sx={{
              p: 2,
              mb: 1,
              width: 340,
              maxWidth: '100%',
              whiteSpace: 'normal',
              border: '1px solid #e6ce82'
            }}
          >
            <Typography variant="body2" sx={{ mb: 1 }}>
              Publishing opens worker bidding; it does not approve the quote or
              change deposits.
            </Typography>
            <Link
              href={`/dashboards/jobTracker/positions/${eventId}?tab=quote`}
              onClick={(event) => {
                const path = `/dashboards/jobTracker/positions/${eventId}?tab=quote`;
                if (!requestAdminNavigation(() => window.location.assign(path)))
                  event.preventDefault();
              }}
            >
              Review Quote
            </Link>
          </Paper>
        </Popper>
      </Box>
    </ClickAwayListener>
  );
}
